import { BizProcessEntity } from '../../abstract-biz-process-entity';
import { ICreationProcessEntity } from '../interface-creation-process-entity';

/**
 * çåæµç¨å®ä½ç±»
 */
export class AifCreationProcessEntity extends BizProcessEntity implements ICreationProcessEntity {
    CreationRuleMetadataId: string;

    CreationRuleId: string;

}